export function formatPhoneNumber(phone: string): string {
  // Remove all non-digit characters
  let digits = phone.replace(/\D/g, '');

  // Remove leading zeros
  while (digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  // Remove leading country code if present
  if (digits.startsWith('57') && digits.length > 10) {
    digits = digits.slice(2);
  }

  // Now, if we have 10 digits, format as Colombian number
  if (digits.length === 10) {
    return `+57 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // Fallback: return original phone
  return phone;
} 